import { render, staticRenderFns } from "./settingItem.vue?vue&type=template&id=688f2cb8&scoped=true&"
import script from "./settingItem.vue?vue&type=script&lang=js&"
export * from "./settingItem.vue?vue&type=script&lang=js&"
import style0 from "./settingItem.vue?vue&type=style&index=0&id=688f2cb8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688f2cb8",
  null
  
)

export default component.exports